/** Nuqtali yo'l bo'yicha o'qish/yozish: "hot.massFlow". Yozish — immutabel (klon). */

export function getPath(obj: unknown, path: string): unknown {
  let cur: unknown = obj;
  for (const key of path.split('.')) {
    if (cur === null || cur === undefined || typeof cur !== 'object') return undefined;
    cur = (cur as Record<string, unknown>)[key];
  }
  return cur;
}

export function setPath<T>(obj: T, path: string, value: unknown): T {
  const keys = path.split('.');
  const clone = (o: unknown): Record<string, unknown> =>
    o && typeof o === 'object' ? { ...(o as Record<string, unknown>) } : {};
  const root = clone(obj);
  let cur = root;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i] as string;
    cur[k] = clone(cur[k]);
    cur = cur[k] as Record<string, unknown>;
  }
  cur[keys[keys.length - 1] as string] = value;
  return root as T;
}

/** Chuqur klon — faqat JSON-ga mos qiymatlar uchun */
export function deepClone<T>(v: T): T {
  return JSON.parse(JSON.stringify(v)) as T;
}

/** Obyekt ichidagi barcha "$name" satrlarini `values` dan almashtiradi */
export function substituteRefs(obj: unknown, values: Record<string, unknown>): unknown {
  if (typeof obj === 'string') {
    if (obj.startsWith('$')) {
      const name = obj.slice(1);
      if (!(name in values)) throw new Error(`Unresolved variant reference: ${obj}`);
      return values[name];
    }
    return obj;
  }
  if (Array.isArray(obj)) return obj.map((v) => substituteRefs(v, values));
  if (obj && typeof obj === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
      out[k] = substituteRefs(v, values);
    }
    return out;
  }
  return obj;
}

export function roundTo(value: number, decimals: number): number {
  const f = Math.pow(10, decimals);
  return Math.round(value * f) / f;
}
